import { inject, observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { RequesAttachedFiles, RequesFormBorrowerGuarantorList, RequesLoanDetails, RequestStepIcon } from ".";
// import { Loading } from "../../../../components/common/loading";
import { IRequestModel,IRequestItemModel } from "../RequestModel";
import { IAuthModel } from "../../../../modules/auth/AuthModel";
import { hasPermission } from "../../../../utils/render-by-permission";
import { Form } from "semantic-ui-react";
import { fetchNoService } from "../../../../utils/request-noservice";
import { PermissionControl, NoPermissionMessage } from "../../../../components/permission";
import { ClickLinkModal } from "../../../../modals";
import { number } from "mobx-state-tree/dist/internal";


interface IRequestFormBody extends WithTranslation, RouteComponentProps {
  request: IRequestModel;
  mode: "editMode" | "createMode";
  authStore?: IAuthModel;
}

@inject("authStore")
@observer
class RequestFormBody extends React.Component<IRequestFormBody> {
  public componentDidMount() {
    if (this.props.mode === "createMode") {
      if (this.props.request.requestItems.length === 0) {
        this.props.request.setRequestItems();
      }
    }
  }
  public state = { step: 1 };
  public render() {
    const { request, mode, history } = this.props;
    if (hasPermission("REQUEST.ONLINE.CREATE") && (request.status === "NWO" || request.status === "NWG" || request.status === "NW" || request.status === "QF"
      || request.status === "AP1" || request.status === "AP2" || request.status === "AP3" || request.status === "DN")) {
      return (<NoPermissionMessage />);
    } else {
      return (
        <Form onSubmit={this.onNextStep}>
          <React.Fragment>
            {/* <Loading active={request!.loading} /> */}
            <RequestStepIcon
              step={this.state.step}
              onNextStep={this.onNextStep}
              onPreviousStep={this.onPreviousStep}
              onClickStep={(index) => this.setState({ step: index })}
              onSave={this.onSave}
              onCreate={this.onCreate}
              hideSubmitButton={(request.status === "DF" || "DFO") || !request.id ? false : true}
              isInvalid={request.checkTotalBudgetAllocationItems}
            />
            {this.state.step === 1 ? <RequesFormBorrowerGuarantorList mode={mode} request={request} /> : null}
            {this.state.step === 2 ? <RequesLoanDetails request={request} mode={mode} /> : null}
            {this.state.step === 3 ? <RequesAttachedFiles request={request} mode={mode} /> : null}

            <RequestStepIcon
              step={this.state.step}
              onNextStep={this.onNextStep}
              onPreviousStep={this.onPreviousStep}
              onClickStep={(index) => this.setState({ step: index })}
              onSave={this.onSave}
              onCreate={this.onCreate}
              hideSubmitButton={(request.status === "DF" || "DFO") || !request.id ? false : true}
              positionBottom
              isInvalid={request.checkTotalBudgetAllocationItems}
            />
          </React.Fragment>
          {hasPermission("REQUEST.ONLINE.CREATE") && (mode == "editMode" || request.successRequestOnline) ? <ClickLinkModal /> : null}
          {hasPermission("REQUEST.ONLINE.CREATE") && (request.successRequestOnline && request.id && request.requestType) ? history.push(`/loan/request/edit/${request.id}/${request.requestType}`) : null}
        </Form>
      );
    }
  }
  private onSave = async () => {
    const { request, history, location, t, authStore } = this.props;
    const pathname = location.pathname;
    try {
        if (request.requestItems && request.requestItems.length>0) {
          this.checkBorrowerErorr();
          this.checkGuarantorErorr();
          this.checkGuarantorCompanyErorr();
          request.requestItems.map((data: IRequestItemModel, index: number) => {
            if(data.checkCompareProvince){
              this.showMessageError("",t("module.loan.guaranteeDetail.checkHouseRegistration"));
          }
            if(request.requestType=="P" &&data.guarantor.occupation.checkSalary){
                this.showMessageError("",t("module.loan.components.checkSalary"));
            }else if(request.requestType=="G" && data.guarantor.occupation.checkSalaryGroup){
              this.showMessageError("",t("module.loan.components.checkSalaryG"));
            }
            if([1].includes(data.borrower.marriageStatus)){
              if(!data.spouse.idCardNo || !data.spouse.firstname || !data.spouse.lastname){
                this.showMessageError("","โปรดกรอกข้อมูลคู่สมรสของผู้กู้");
              }else{
                if(data.spouse.idCardNo){
                    // console.log("data.borrower.isVerify",data.borrower.isVerify)
                    // if(!data.borrower.isVerify){
                    //   this.showMessageError("","โปรดกรอกตรวจสอบคุณสมบัติคู่สมรสของผู้กู้ ให้ผ่านก่อนบันทึก");
                    // }
                }
              }
            }
            if([1].includes(data.guarantor.marriageStatus)){
              if(!data.guarantorSpouse.idCardNo || !data.guarantorSpouse.firstname || !data.guarantorSpouse.lastname){
                this.showMessageError("","โปรดกรอกข้อมูลคู่สมรสของผู้ค้ำ");
              }else{
                if(data.guarantorSpouse.idCardNo){
                    // console.log("data.borrower.isVerify",data.borrower.isVerify)
                    // if(!data.guarantor.isVerify){
                    //   this.showMessageError("","โปรดกรอกตรวจสอบคุณสมบัติคู่สมรสของผู้ค้ำ ให้ผ่านก่อนบันทึก");
                    // }
                }
              }
            }
            
          })
      }
      if (request.checkTotalBudgetAllocationItems && request.requestBudget != '0.00') {
        const errorMessage = {
          code: "",
          name: "",
          message: t("module.loan.budgetAllocationItem.estimatedCostLessAmountRequested"),
          technical_stack: "",
        };
        request.error.setErrorMessage(errorMessage);
        throw errorMessage;
      }
      if (request.id) {
        if (pathname === "/loan/request/create") {
          history.push(`/loan/request/edit/${request.id}/${request.requestType}`);
        } else {
          await request!.updateRequestAll();
          await request!.getRequestDetail();
          await request!.setRequestItemsAttachedFiles();
          if (request.requestItems.length && request.requestItems[0].id) {
            await request.requestItems[0].getAttachedFiles(request.id || "");
          }
        }
      } else {
        await request!.createRequest();
      }
    } catch (e) {
      console.log(e);
    }
  };
  private onNextStep = async () => {
    switch (this.state.step) {
      case 1:
        await this.sendFormStep1();
        break;
      case 2:
        await this.sendFormStep2();
        break;
    }
  };
  private onPreviousStep = async () => {
    if (this.state.step > 1) {
      this.setState({ step: this.state.step - 1 });
    }
  };

  private sendFormStep2 = async () => {
    const { request, t, authStore } = this.props;
    try {
      if (hasPermission("REQUEST.ONLINE.CREATE")
        && !request.requestOccupation.id) {
        const errorMessage = {
          code: "",
          name: "",
          message: "โปรดกรอกเลือกข้อมูลหัวข้อเพื่อนำไปประกอบอาชีพ",
          technical_stack: "",
        };
        request.error.setErrorMessage(errorMessage);
        throw errorMessage;
      }
      if (hasPermission("REQUEST.ONLINE.CREATE")
        && (request.requestOccupationAddress.latitude == "" || request.requestOccupationAddress.longitude == "")) {
        const errorMessage = {
          code: "",
          name: "",
          message: "โปรดกรอกระบุข้อมูลแผนผังสถานที่ประกอบอาชีพ",
          technical_stack: "",
        };
        request.error.setErrorMessage(errorMessage);
        throw errorMessage;
      }
      if (!request.checkTotalBudgetAllocationItems && request.requestBudget != '0.00') {
        if (request.id) {
          await request.updateRequesLoanDetails();
        } else {
          if (hasPermission("REQUEST.ONLINE.CREATE") && !request.id) {
            await request!.setRequestItemsAttachedFiles();
          } else {
            await request!.createRequest();
          }
        }
        await this.setState({ step: 3 });
      } else {
        const errorMessage = {
          code: "",
          name: "",
          message: t("module.loan.budgetAllocationItem.estimatedCostLessAmountRequested"),
          technical_stack: "",
        };
        request.error.setErrorMessage(errorMessage);
        throw errorMessage;
      }
    } catch (e) {
      console.log(e);
    }
  };
  private sendFormStep1 = async () => {
    const { request, authStore,t } = this.props;
    try {
      // console.log(request.requestItems[0].borrower.residenceStatusTypeDescription)
      
      if (request.requestItems && request.requestItems.length>0) {
        this.checkBorrowerErorr();
        this.checkGuarantorErorr();
        this.checkGuarantorCompanyErorr();
        request.requestItems.map((data: IRequestItemModel, index: number) => {
          if(data.checkCompareProvince){
            this.showMessageError("",t("module.loan.guaranteeDetail.checkHouseRegistration"));
        }
        if(request.requestType=="P" &&data.guarantor.occupation.checkSalary){
          this.showMessageError("",t("module.loan.components.checkSalary"));
      }else if(request.requestType=="G" && data.guarantor.occupation.checkSalaryGroup){
        this.showMessageError("",t("module.loan.components.checkSalaryG"));
      }
          if([1].includes(data.borrower.marriageStatus)){
            if(!data.spouse.idCardNo || !data.spouse.firstname || !data.spouse.lastname){
              this.showMessageError("","โปรดกรอกข้อมูลคู่สมรสของผู้กู้");
            }else{
              if(data.spouse.idCardNo){
                  // console.log("data.borrower.isVerify",data.borrower.isVerify)
                  if(!data.spouse.isVerify){
                    this.showMessageError("","โปรดกรอกตรวจสอบคุณสมบัติคู่สมรสของผู้กู้ ให้ผ่านก่อนบันทึก");
                  }
              }
            }
          }
          if([1].includes(data.guarantor.marriageStatus)){
            if(!data.guarantorSpouse.idCardNo || !data.guarantorSpouse.firstname || !data.guarantorSpouse.lastname){
              this.showMessageError("","โปรดกรอกข้อมูลคู่สมรสของผู้ค้ำ");
            }else{
              if(data.guarantorSpouse.idCardNo){
                  // console.log("data.borrower.isVerify",data.borrower.isVerify)
                  // if(!data.guarantorSpouse.isVerify){
                  //   this.showMessageError("","โปรดกรอกตรวจสอบคุณสมบัติคู่สมรสของผู้ค้ำ ให้ผ่านก่อนบันทึก");
                  // }
              }
            }
          }
          
        })
      }
      if (request.id) {
        await request!.updateRequest();
        if (hasPermission("REQUEST.ONLINE.CREATE")) {
          await request!.updateRequestAll();
          await request!.getRequestDetail();
          await request!.setRequestItemsAttachedFiles();
          if (request.requestItems.length && request.requestItems[0].id) {
            await request.requestItems[0].getAttachedFiles(request.id || "");
          }
        }
      } else {
        if (hasPermission("REQUEST.ONLINE.CREATE") && !request.id) {
          //exit
        } else {
          await request!.createRequest();
        }
      }
      await this.setState({ step: 2 });
    } catch (e) {
      console.log(e);
    }
  };

  private onCreate = async () => {
    const { request, history, t, authStore } = this.props;
    try {
      if (request.requestItems && request.requestItems.length>0) {
        this.checkBorrowerErorr();
        this.checkGuarantorErorr();
        this.checkGuarantorCompanyErorr();
        request.requestItems.map((data: IRequestItemModel, index: number) => {
          
          if(data.checkCompareProvince){
            this.showMessageError("",t("module.loan.guaranteeDetail.checkHouseRegistration"));
        }
        if(request.requestType=="P" &&data.guarantor.occupation.checkSalary){
          this.showMessageError("",t("module.loan.components.checkSalary"));
      }else if(request.requestType=="G" && data.guarantor.occupation.checkSalaryGroup){
        this.showMessageError("",t("module.loan.components.checkSalaryG"));
      }
          if([1].includes(data.borrower.marriageStatus)){
            if(!data.spouse.idCardNo || !data.spouse.firstname || !data.spouse.lastname){
              this.showMessageError("","โปรดกรอกข้อมูลคู่สมรสของผู้กู้");
            }else{
              if(data.spouse.idCardNo){
                  // console.log("data.borrower.isVerify",data.borrower.isVerify)
                  // if(!data.borrower.isVerify){
                  //   this.showMessageError("","โปรดกรอกตรวจสอบคุณสมบัติคู่สมรสของผู้กู้ ให้ผ่านก่อนบันทึก");
                  // }
              }
            }
          }
          if([1].includes(data.guarantor.marriageStatus)){
            if(!data.guarantorSpouse.idCardNo || !data.guarantorSpouse.firstname || !data.guarantorSpouse.lastname){
              this.showMessageError("","โปรดกรอกข้อมูลคู่สมรสของผู้ค้ำ");
            }else{
              if(data.guarantorSpouse.idCardNo){
                  // console.log("data.borrower.isVerify",data.borrower.isVerify)
                  // if(!data.guarantor.isVerify){
                  //   this.showMessageError("","โปรดกรอกตรวจสอบคุณสมบัติคู่สมรสของผู้ค้ำ ให้ผ่านก่อนบันทึก");
                  // }
              }
            }
          }
          
        })
      }
      if (request.checkTotalBudgetAllocationItems && request.requestBudget != '0.00') {
        const errorMessage = {
          code: "",
          name: "",
          message: t("module.loan.budgetAllocationItem.estimatedCostLessAmountRequested"),
          technical_stack: "",
        };
        request.error.setErrorMessage(errorMessage);
        throw errorMessage;
      }
      if (request.id) {
        await request!.updateRequestStatusCreate();
      } else {
        await request!.createRequestAllStatusCreate();
        history.push(`/loan/request/edit/${request.id}/${request.requestType}`);
      }
      history.push(`/loan/request/view/${request.id}/${request.requestType}`);
    } catch (e) {
      console.log(e);
    }
  };
  private showMessageError(messageName:string,message : string){
    const {t,request} =this.props
    const errorMessage = {
      code: "",
      name: messageName,
      message: message
    };
    request.error.setErrorMessage(errorMessage);
    throw errorMessage;
  }
  private checkEmptyOrNull(field:any){
    if(typeof field!='undefined' && field){
        return false;
    }else{
      return true;
    }
  }
  private checkBorrowerErorr(){
    const {t,request} =this.props;
    let message ="";
    request.requestItems.map((data: IRequestItemModel, index: number) => {
      if(this.checkEmptyOrNull(data.borrower.nationality)){
        message =message +" -สัญชาติ ";
        }
      if(this.checkEmptyOrNull(data.borrower.idCardIssuer)){
        message =message +" -ออกโดย ";
        }
        if(this.checkEmptyOrNull(data.borrower.idCardIssuedDate)){
          message =message +" -วันที่ออกบัตร ";
          }
          if(this.checkEmptyOrNull(data.borrower.idCardExpireDate) && !data.borrower.idCardLifetime ){
            message =message +" -วันหมดอายุ ";
            }
        if(this.checkEmptyOrNull(data.borrower.idCardAddress.houseNo)){
          message =message +" -บ้านเลขที่ ";
          }
            if(this.checkEmptyOrNull(data.borrower.idCardAddress.hmoo)){
              message =message +" -หมู่ที่ ";
          }
          if(this.checkEmptyOrNull(data.borrower.idCardAddress.subDistrictCode)){
            message =message +" -ตำบล/แขวง";
            }
            if(this.checkEmptyOrNull(data.borrower.idCardAddress.districtCode)){
              message =message +" -อำเภอ/เขต";
          }
          if(this.checkEmptyOrNull(data.borrower.idCardAddress.provinceCode)){
            message =message +" -จังหวัด";
          }
          if(this.checkEmptyOrNull(data.borrower.idCardAddress.zipcode)){
            message =message +" -รหัสไปรษณีย์";
          }
          if(data.borrower.marriageStatus === 1){
                if(this.checkEmptyOrNull(data.spouse.idCardNo)){
                  message =message +" -หมายเลขบัตรประชาชน (ข้อมูลคู่สมรสผู้กู้)";
                }
                if(this.checkEmptyOrNull(data.spouse.idCardIssuer)){
                message =message +" -ออกโดย (ข้อมูลคู่สมรสผู้กู้)";
                }
                if(this.checkEmptyOrNull(data.spouse.idCardIssuedDate)){
                message =message +" -วันที่ออกบัตร (ข้อมูลคู่สมรสผู้กู้)";
                }
                if(this.checkEmptyOrNull(data.spouse.idCardExpireDate) && !data.spouse.idCardLifetime ){
                  message =message +" -วันหมดอายุ (ข้อมูลคู่สมรสผู้กู้)";
                }
                if(this.checkEmptyOrNull(data.spouse.title)){
                  message =message +" -คำนำหน้าชื่อ (ข้อมูลคู่สมรสผู้กู้)";
                }
                if(this.checkEmptyOrNull(data.spouse.firstname)){
                  message =message +" -ชื่อ (ข้อมูลคู่สมรสผู้กู้)";
                }
                if(this.checkEmptyOrNull(data.spouse.lastname)){
                    message =message +" -นามสกุล (ข้อมูลคู่สมรสผู้กู้)";
                }
                if(this.checkEmptyOrNull(data.spouse.birthDate)){
                  message =message +" -วัน เดือน ปีเกิด (ข้อมูลคู่สมรสผู้กู้)";
              }
          }
          if(data.borrower.registeredAddressType === 99){
            if(this.checkEmptyOrNull(data.borrower.registeredAddress.houseNo)){
              message =message +" -บ้านเลขที่ (ที่อยู่ตามทะเบียนบ้าน)";
              }
                if(this.checkEmptyOrNull(data.borrower.registeredAddress.hmoo)){
                  message =message +" -หมู่ที่ (ที่อยู่ตามทะเบียนบ้าน)";
              }
              if(this.checkEmptyOrNull(data.borrower.registeredAddress.subDistrictCode)){
                message =message +" -ตำบล/แขวง (ที่อยู่ตามทะเบียนบ้าน)";
                }
                if(this.checkEmptyOrNull(data.borrower.registeredAddress.districtCode)){
                  message =message +" -อำเภอ/เขต (ที่อยู่ตามทะเบียนบ้าน)";
              }
              if(this.checkEmptyOrNull(data.borrower.registeredAddress.provinceCode)){
                message =message +" -จังหวัด (ที่อยู่ตามทะเบียนบ้าน)";
              }
              if(this.checkEmptyOrNull(data.borrower.registeredAddress.zipcode)){
                message =message +" -รหัสไปรษณีย์ (ที่อยู่ตามทะเบียนบ้าน)";
              }
          }
          if(data.borrower.currentAddressType === 99){
            if(this.checkEmptyOrNull(data.borrower.currentAddress.houseNo)){
              message =message +" -บ้านเลขที่ (ที่อยู่ปัจจุบัน)";
              }
                if(this.checkEmptyOrNull(data.borrower.currentAddress.hmoo)){
                  message =message +" -หมู่ที่ (ที่อยู่ปัจจุบัน)";
              }
              if(this.checkEmptyOrNull(data.borrower.currentAddress.subDistrictCode)){
                message =message +" -ตำบล/แขวง (ที่อยู่ปัจจุบัน)";
                }
                if(this.checkEmptyOrNull(data.borrower.currentAddress.districtCode)){
                  message =message +" -อำเภอ/เขต (ที่อยู่ปัจจุบัน)";
              }
              if(this.checkEmptyOrNull(data.borrower.currentAddress.provinceCode)){
                message =message +" -จังหวัด (ที่อยู่ปัจจุบัน)";
              }
              if(this.checkEmptyOrNull(data.borrower.currentAddress.zipcode)){
                message =message +" -รหัสไปรษณีย์ (ที่อยู่ปัจจุบัน)";
              }
          }
          
          if(this.checkEmptyOrNull(data.borrower.telephone)){
            message =message +" -หมายเลขโทรศัพท์มือถือ";
          }
          if ( (data.borrower.residenceStatusType === 0
          || data.borrower.residenceStatusType === 1)
        && (data.borrower.residenceStatusTypeDescription == "0" || !data.borrower.residenceStatusTypeDescription || data.borrower.residenceStatusTypeDescription ==="")) {
        this.showMessageError("","โปรดกรอกค่าเช่า/ผ่อน หรือ อื่นๆในหัวข้อสถานะการอยู่อาศัยของผู้กู้");
      }
    });
    if(message!=""){
      this.showMessageError("โปรดกรอกข้อมูลให้ครบ (ผู้กู้)",message);
    }
  }
  private checkGuarantorErorr(){
    const {t,request} =this.props;
    let message ="";
    request.requestItems.map((data: IRequestItemModel, index: number) => {
      if(this.checkEmptyOrNull(data.guarantor.nationality)){
        message =message +" -สัญชาติ ";
        }
      if(this.checkEmptyOrNull(data.guarantor.idCardIssuer)){
        message =message +" -ออกโดย ";
        }
        if(this.checkEmptyOrNull(data.guarantor.idCardIssuedDate)){
          message =message +" -วันที่ออกบัตร ";
          }
          if(this.checkEmptyOrNull(data.guarantor.idCardExpireDate) && !data.guarantor.idCardLifetime ){
            message =message +" -วันหมดอายุ ";
            }
        if(this.checkEmptyOrNull(data.guarantor.idCardAddress.houseNo)){
          message =message +" -บ้านเลขที่ ";
          }
            if(this.checkEmptyOrNull(data.guarantor.idCardAddress.hmoo)){
              message =message +" -หมู่ที่ ";
          }
          if(this.checkEmptyOrNull(data.guarantor.idCardAddress.subDistrictCode)){
            message =message +" -ตำบล/แขวง";
            }
            if(this.checkEmptyOrNull(data.guarantor.idCardAddress.districtCode)){
              message =message +" -อำเภอ/เขต";
          }
          if(this.checkEmptyOrNull(data.guarantor.idCardAddress.provinceCode)){
            message =message +" -จังหวัด";
          }
          if(this.checkEmptyOrNull(data.guarantor.idCardAddress.zipcode)){
            message =message +" -รหัสไปรษณีย์";
          }
          if(data.guarantor.registeredAddressType === 99){
            if(this.checkEmptyOrNull(data.guarantor.registeredAddress.houseNo)){
              message =message +" -บ้านเลขที่ (ที่อยู่ตามทะเบียนบ้าน)";
              }
                if(this.checkEmptyOrNull(data.guarantor.registeredAddress.hmoo)){
                  message =message +" -หมู่ที่ (ที่อยู่ตามทะเบียนบ้าน)";
              }
              if(this.checkEmptyOrNull(data.guarantor.registeredAddress.subDistrictCode)){
                message =message +" -ตำบล/แขวง (ที่อยู่ตามทะเบียนบ้าน)";
                }
                if(this.checkEmptyOrNull(data.guarantor.registeredAddress.districtCode)){
                  message =message +" -อำเภอ/เขต (ที่อยู่ตามทะเบียนบ้าน)";
              }
              if(this.checkEmptyOrNull(data.guarantor.registeredAddress.provinceCode)){
                message =message +" -จังหวัด (ที่อยู่ตามทะเบียนบ้าน)";
              }
              if(this.checkEmptyOrNull(data.guarantor.registeredAddress.zipcode)){
                message =message +" -รหัสไปรษณีย์ (ที่อยู่ตามทะเบียนบ้าน)";
              }
          }
          if(data.guarantor.currentAddressType === 99){
            if(this.checkEmptyOrNull(data.guarantor.currentAddress.houseNo)){
              message =message +" -บ้านเลขที่ (ที่อยู่ปัจจุบัน)";
              }
                if(this.checkEmptyOrNull(data.guarantor.currentAddress.hmoo)){
                  message =message +" -หมู่ที่ (ที่อยู่ปัจจุบัน)";
              }
              if(this.checkEmptyOrNull(data.guarantor.currentAddress.subDistrictCode)){
                message =message +" -ตำบล/แขวง (ที่อยู่ปัจจุบัน)";
                }
                if(this.checkEmptyOrNull(data.guarantor.currentAddress.districtCode)){
                  message =message +" -อำเภอ/เขต (ที่อยู่ปัจจุบัน)";
              }
              if(this.checkEmptyOrNull(data.guarantor.currentAddress.provinceCode)){
                message =message +" -จังหวัด (ที่อยู่ปัจจุบัน)";
              }
              if(this.checkEmptyOrNull(data.guarantor.currentAddress.zipcode)){
                message =message +" -รหัสไปรษณีย์ (ที่อยู่ปัจจุบัน)";
              }
          }
          if(this.checkEmptyOrNull(data.guarantor.telephone)){
            message =message +" -หมายเลขโทรศัพท์มือถือ";
          }
          
      if ( (data.guarantor.residenceStatusType === 0
        || data.guarantor.residenceStatusType === 1)
      && (data.guarantor.residenceStatusTypeDescription == "0" || !data.guarantor.residenceStatusTypeDescription || data.guarantor.residenceStatusTypeDescription=="")) {
      this.showMessageError("","โปรดกรอกค่าเช่า/ผ่อน หรือ อื่นๆในหัวข้อสถานะการอยู่อาศัยของผู้ค้ำ");
    }
    if ((data.guarantor.occupation.salary == "0" || !data.guarantor.occupation.salary)) {
      this.showMessageError("","โปรดกรอกรายได้ของผู้ค้ำ");
    }
    });
    if(message!=""){
      this.showMessageError("โปรดกรอกข้อมูลให้ครบ (ผู้ค้ำ)",message);
    }
  }
  private checkGuarantorCompanyErorr(){
    const {t,request} =this.props;
    let message ="";
    request.requestItems.map((data: IRequestItemModel, index: number) => {
        if(this.checkEmptyOrNull(data.guarantorCompanyAddress.houseNo)){
          message =message +" -บ้านเลขที่ (ที่อยู่บริษัทข้อมูลผู้ค้ำ)";
          }
            if(this.checkEmptyOrNull(data.guarantorCompanyAddress.hmoo)){
              message =message +" -หมู่ที่ (ที่อยู่บริษัทข้อมูลผู้ค้ำ)";
          }
          if(this.checkEmptyOrNull(data.guarantorCompanyAddress.subDistrictCode)){
            message =message +" -ตำบล/แขวง (ที่อยู่บริษัทข้อมูลผู้ค้ำ)";
            }
            if(this.checkEmptyOrNull(data.guarantorCompanyAddress.districtCode)){
              message =message +" -อำเภอ/เขต (ที่อยู่บริษัทข้อมูลผู้ค้ำ)";
          }
          if(this.checkEmptyOrNull(data.guarantorCompanyAddress.provinceCode)){
            message =message +" -จังหวัด (ที่อยู่บริษัทข้อมูลผู้ค้ำ)";
          }
          if(this.checkEmptyOrNull(data.guarantorCompanyAddress.zipcode)){
            message =message +" -รหัสไปรษณีย์ (ที่อยู่บริษัทข้อมูลผู้ค้ำ)";
          }
    });
    if(message!=""){
      this.showMessageError("โปรดกรอกข้อมูลให้ครบ (ที่อยู่บริษัทผู้ค้ำ)",message);
    }
  }
  private checkStep2Erorr(){
    const {t,request} =this.props;
    let message ="";
    if(this.checkEmptyOrNull(request.requestOccupation.salary)){
      message =message +" -ยอดเงิน";
      }
        if(this.checkEmptyOrNull(request.requestOccupation.id)){
          message =message +" -เพื่อนำไปประกอบอาชีพ";
          }
          if(this.checkEmptyOrNull(request.requestOccupation.description)){
            message =message +" -รายละเอียด เพื่อนำไปประกอบอาชีพ";
            }
    if(message!=""){
      this.showMessageError("โปรดกรอกข้อมูลให้ครบ (ประสงค์กู้เงิน)",message);
    }
  }
}
export default withRouter(withTranslation()(RequestFormBody));
